import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { client } from 'src/api/liveblocks-client';
import { PopUpNotification } from 'src/features/notifications/pop-up-notification';
import { NotificationProps } from 'src/features/notifications/types';
import { useAuth } from 'src/shared/hooks/use-auth';
import { useLayout } from 'src/shared/hooks/use-layout';

export const LiveActions = () => {
  const authData = useAuth((s) => s.userDetails);
  //Member ID is unique in every organisation
  const memberId = authData?.memberInformation?.memberId;
  const { setLiveActionType, liveActionType } = useLayout();
  const roomId = memberId;
  const router = useRouter();
  const { room, leave } = client.enterRoom(roomId, {
    initialPresence: { cursor: null },
  });
  const status = room.getStatus();
  const [notificationPayload, setNotificationPayload] = useState<NotificationProps>();

  const subscribeToLiveActions = async () => {
    room.subscribe('event', (data) => {
      if (data?.event?.type) {
        setLiveActionType(data?.event?.type);

        if (data?.event?.type === 'notification') {
          setNotificationPayload(data?.event?.payload?.data);
        }
      }
    });
  };

  useEffect(() => {
    if (status === 'connected' && memberId) {
      subscribeToLiveActions();
    }
    return () => {
      leave();
      setLiveActionType(null);
    };
  }, [status, memberId]);

  const handleResetNotificationPayload = () => {
    setNotificationPayload(undefined);
  };
  useEffect(() => {
    if (liveActionType === 'reload-app') {
      router.reload();
      setLiveActionType(null);
    }
  }, [liveActionType]);

  const handleLiveAction = useCallback(() => {
    switch (liveActionType) {
      case 'notification':
        return notificationPayload?.type ? (
          <PopUpNotification
            notificationPayload={notificationPayload}
            handleResetNotificationPayload={handleResetNotificationPayload}
          />
        ) : (
          <></>
        );

      default:
        return <></>;
    }
  }, [liveActionType, notificationPayload?.id]);

  return <>{handleLiveAction()}</>;
};
